import { Resend } from 'resend';

const sendPartnershipEmail = async (formData) => {
  try {
    const response = await fetch('/api/emails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        from: import.meta.env.VITE_EMAIL_FROM,
        to: import.meta.env.VITE_EMAIL_TO,
        subject: `Partnership Request: ${formData.subject}`,
        html: `
          <h2>New Partnership Request</h2>
          <p><strong>Name:</strong> ${formData.name}</p>
          <p><strong>Email:</strong> ${formData.email}</p>
          <p><strong>Company:</strong> ${formData.company}</p>
          <p><strong>Message:</strong> ${formData.message}</p>
        `
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Failed to send email:', error);
    console.error('Error details:', error);
    return { success: false, error: error.message, details: error.response };
  }
};

export { sendPartnershipEmail }; 